module.exports = __webpack_public_path__ + "img/wb.88966e14.webp";